import { render, staticRenderFns } from "./MemberPeriods.vue?vue&type=template&id=337249f9&scoped=true"
import script from "./MemberPeriods.vue?vue&type=script&lang=js"
export * from "./MemberPeriods.vue?vue&type=script&lang=js"
import style0 from "./MemberPeriods.vue?vue&type=style&index=0&id=337249f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337249f9",
  null
  
)

export default component.exports